import {ISiteConfiguration} from "../domain/ISiteConfiguration";
import {Matrix4} from "cesium";
import {useContext} from "react";
import {ISiteDataActions, SiteDataContext2} from "../components/Contexts/SiteDataContextProvider";

export const useSiteConfig = (): [ISiteConfiguration, ISiteDataActions] => {
  const [siteConfiguration, actions ] = useContext(SiteDataContext2);
  return [ siteConfiguration, actions ] ;
}
